import { useState, useRef, useEffect } from 'react';
import { TextField, Button, Grid, Typography, Paper } from '@mui/material';
import { apiChat } from '../../services/chat/Chat';

const PromptComponent = () => {
    const isAuthenticated =
        localStorage.getItem('token') !== null &&
        localStorage.getItem('token') !== '';
    const [input, setInput] = useState('');
    const [answers, setAnswers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const bottomRef = useRef(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isLoading) {
            setIsLoading(true);
            let result = await apiChat.post({ body: input });
            if (result.response) {
                setIsLoading(false);
                const newItems = [
                    { body: input, isTitle: true },
                    { body: result.response, isTitle: false },
                ];
                // Update the state with the new items at the start
                setAnswers([...newItems, ...answers]);
                setInput('');
            }
        }
    };

    useEffect(() => {
        if (!isAuthenticated) window.location.href = '/login';
    }, [isAuthenticated]);

    return (
        <div className="home-container">
            <br />
            <br />
            <div className="home-hero">
                <Grid
                    container
                    justifyContent="center"
                    className="padding-body-2"
                >
                    <Grid item xs={12} sm={6} md={6}>
                        <Paper elevation={3} variant="outlined" square>
                            <form onSubmit={handleSubmit}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Typography variant="h5" gutterBottom>
                                            CHAT GPT - zadaj pytanie
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Zadaj pytanie jakie chcesz!!!"
                                            multiline
                                            rows={4}
                                            fullWidth
                                            value={input}
                                            onChange={(e) =>
                                                setInput(e.target.value)
                                            }
                                        />
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            fullWidth
                                            size="large"
                                            className="buttonFilled"
                                        >
                                            {isLoading && (
                                                <span className="loader"></span>
                                            )}
                                            {!isLoading && <span>Zapytaj</span>}
                                        </Button>
                                    </Grid>
                                    <br />
                                    <Grid item xs={12} className="chat-array">
                                        {answers.map((row, index) => {
                                            return (
                                                <div className="chat-gpt">
                                                    {row.isTitle && (
                                                        <h5>{row.body}</h5>
                                                    )}
                                                    {!row.isTitle && (
                                                        <p>{row.body}</p>
                                                    )}
                                                </div>
                                            );
                                        })}
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <div ref={bottomRef}></div>
                                    </Grid>
                                </Grid>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default PromptComponent;
